function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * @module API
 */
import { extend } from './util';
var api = {};
var $ = {}; // Import modules to build up the API

import * as array from './array';
import BaseClass from './baseClass';
import * as css from './css';
import * as dom from './dom/index';
import * as dom_attr from './dom/attr';
import * as dom_class from './dom/class';
import * as dom_contains from './dom/contains';
import * as dom_data from './dom/data';
import * as dom_extra from './dom/extra';
import * as dom_html from './dom/html';
import * as event from './event/index';
import * as event_trigger from './event/trigger';
import * as event_ready from './event/ready';
import * as noconflict from './noconflict';
import * as selector from './selector/index';
import * as selector_closest from './selector/closest';
import * as selector_extra from './selector/extra';
import * as type from './type';

if (typeof _get__("selector") !== 'undefined') {
  _assign__("$", _get__("selector").$);

  _get__("$").matches = _get__("selector").matches;
  _get__("api").find = _get__("selector").find;
}

_get__("extend")(_get__("$"), _get__("dom_contains"), _get__("noconflict"), _get__("type"));

_get__("extend")(_get__("api"), _get__("array"), _get__("css"), _get__("dom_attr"), _get__("dom"), _get__("dom_class"), _get__("dom_data"), _get__("dom_extra"), _get__("dom_html"), _get__("event"), _get__("event_trigger"), _get__("event_ready"), _get__("selector_closest"), _get__("selector_extra"));

_get__("$").fn = _get__("api"); // Version

_get__("$").version = '__VERSION__'; // Util

_get__("$").extend = _get__("extend"); // Provide base class to extend from

if (typeof _get__("BaseClass") !== 'undefined') {
  _get__("$").BaseClass = _get__("BaseClass")(_get__("$").fn);
} // Export interface


export default _get__("$");

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "selector":
      return _filterWildcardImport__(selector);

    case "$":
      return $;

    case "api":
      return api;

    case "extend":
      return extend;

    case "dom_contains":
      return _filterWildcardImport__(dom_contains);

    case "noconflict":
      return _filterWildcardImport__(noconflict);

    case "type":
      return _filterWildcardImport__(type);

    case "array":
      return _filterWildcardImport__(array);

    case "css":
      return _filterWildcardImport__(css);

    case "dom_attr":
      return _filterWildcardImport__(dom_attr);

    case "dom":
      return _filterWildcardImport__(dom);

    case "dom_class":
      return _filterWildcardImport__(dom_class);

    case "dom_data":
      return _filterWildcardImport__(dom_data);

    case "dom_extra":
      return _filterWildcardImport__(dom_extra);

    case "dom_html":
      return _filterWildcardImport__(dom_html);

    case "event":
      return _filterWildcardImport__(event);

    case "event_trigger":
      return _filterWildcardImport__(event_trigger);

    case "event_ready":
      return _filterWildcardImport__(event_ready);

    case "selector_closest":
      return _filterWildcardImport__(selector_closest);

    case "selector_extra":
      return _filterWildcardImport__(selector_extra);

    case "BaseClass":
      return BaseClass;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {
    case "$":
      return $ = _value;
  }

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (_typeof(variableName) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)["catch"](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = _typeof($);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty($, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible($)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

function _filterWildcardImport__() {
  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
  });
  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
    return filteredWildcardImport;
  }, {});
}

export { _get__ as __get__, _get__ as __GetDependency__, _set__ as __Rewire__, _set__ as __set__, _reset__ as __ResetDependency__, _RewireAPI__ as __RewireAPI__ };